import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type AssetJobsStatus_AudioAsset_Fragment = { __typename?: 'AudioAsset', id: string, assetJobs?: Array<{ __typename: 'BrandValidationAssetJob', id?: string | null } | { __typename: 'GenericAssetJob', id?: string | null } | null> | null };

export type AssetJobsStatus_DocumentAsset_Fragment = { __typename?: 'DocumentAsset', id: string, assetJobs?: Array<{ __typename: 'BrandValidationAssetJob', id?: string | null } | { __typename: 'GenericAssetJob', id?: string | null } | null> | null };

export type AssetJobsStatus_FileAsset_Fragment = { __typename?: 'FileAsset', id: string, assetJobs?: Array<{ __typename: 'BrandValidationAssetJob', id?: string | null } | { __typename: 'GenericAssetJob', id?: string | null } | null> | null };

export type AssetJobsStatus_FolderAsset_Fragment = { __typename?: 'FolderAsset', id: string, assetJobs?: Array<{ __typename: 'BrandValidationAssetJob', id?: string | null } | { __typename: 'GenericAssetJob', id?: string | null } | null> | null };

export type AssetJobsStatus_ImageAsset_Fragment = { __typename?: 'ImageAsset', id: string, assetJobs?: Array<{ __typename: 'BrandValidationAssetJob', id?: string | null } | { __typename: 'GenericAssetJob', id?: string | null } | null> | null };

export type AssetJobsStatus_InteractiveAsset_Fragment = { __typename?: 'InteractiveAsset', id: string, assetJobs?: Array<{ __typename: 'BrandValidationAssetJob', id?: string | null } | { __typename: 'GenericAssetJob', id?: string | null } | null> | null };

export type AssetJobsStatus_InteractiveLiveAsset_Fragment = { __typename?: 'InteractiveLiveAsset', id: string, assetJobs?: Array<{ __typename: 'BrandValidationAssetJob', id?: string | null } | { __typename: 'GenericAssetJob', id?: string | null } | null> | null };

export type AssetJobsStatus_ModelAsset_Fragment = { __typename?: 'ModelAsset', id: string, assetJobs?: Array<{ __typename: 'BrandValidationAssetJob', id?: string | null } | { __typename: 'GenericAssetJob', id?: string | null } | null> | null };

export type AssetJobsStatus_UnsupportedAsset_Fragment = { __typename?: 'UnsupportedAsset', id: string, assetJobs?: Array<{ __typename: 'BrandValidationAssetJob', id?: string | null } | { __typename: 'GenericAssetJob', id?: string | null } | null> | null };

export type AssetJobsStatus_VersionStackAsset_Fragment = { __typename?: 'VersionStackAsset', id: string, assetJobs?: Array<{ __typename: 'BrandValidationAssetJob', id?: string | null } | { __typename: 'GenericAssetJob', id?: string | null } | null> | null };

export type AssetJobsStatus_VideoAsset_Fragment = { __typename?: 'VideoAsset', id: string, assetJobs?: Array<{ __typename: 'BrandValidationAssetJob', id?: string | null } | { __typename: 'GenericAssetJob', id?: string | null } | null> | null };

export type AssetJobsStatusFragment = AssetJobsStatus_AudioAsset_Fragment | AssetJobsStatus_DocumentAsset_Fragment | AssetJobsStatus_FileAsset_Fragment | AssetJobsStatus_FolderAsset_Fragment | AssetJobsStatus_ImageAsset_Fragment | AssetJobsStatus_InteractiveAsset_Fragment | AssetJobsStatus_InteractiveLiveAsset_Fragment | AssetJobsStatus_ModelAsset_Fragment | AssetJobsStatus_UnsupportedAsset_Fragment | AssetJobsStatus_VersionStackAsset_Fragment | AssetJobsStatus_VideoAsset_Fragment;

export const AssetJobsStatus = /*#__PURE__*/ gql`
    fragment AssetJobsStatus on Asset {
  id
  assetJobs {
    id
    __typename
  }
}
    ` as unknown as DocumentNode<AssetJobsStatusFragment, unknown>;

        

        
export const useAssetJobsStatusFragment = (
  input: string | Omit<UseFragmentOptions<AssetJobsStatusFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Asset' } };
    return input;
  })();

  return useFragment<AssetJobsStatusFragment>({
    fragment: AssetJobsStatus,
    fragmentName: 'AssetJobsStatus',
    ...options,
  });
};
  
        